var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.menu, function (section) {
      return _c(
        "b-card",
        {
          key: section.id,
          staticClass: "admin-menu",
          attrs: { "no-body": "" },
        },
        [
          _vm.isPermitted(section.permission)
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle",
                      value: section.id,
                      expression: "section.id",
                    },
                  ],
                  staticStyle: { cursor: "pointer" },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("i", { staticClass: "fa fa-align-justify" }),
                  _c("strong", [_vm._v("  " + _vm._s(section.name))]),
                ]
              )
            : _vm._e(),
          _vm.isPermitted(section.permission)
            ? _c(
                "b-collapse",
                {
                  ref: "accordion",
                  refInFor: true,
                  attrs: {
                    id: section.id,
                    accordion: "admin-accordion",
                    role: "tabpanel",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "list-group",
                      attrs: { id: "list-tab", role: "tablist" },
                    },
                    _vm._l(section.children, function (item) {
                      return _c(
                        "router-link",
                        {
                          key: item.id,
                          ref: item.id,
                          refInFor: true,
                          staticClass: "list-group-item list-group-item-action",
                          attrs: {
                            "data-toggle": "list",
                            role: "tab",
                            hidden: item.hidden,
                            to: "/admin/" + item.route,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.emitEvent(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }